module.exports = __webpack_public_path__ + "img/Weapon_88.b47be3c7.png";